import React, { Component } from "react";
import PropTypes from "prop-types";
import PaginationDots from "./PaginationDots";
import IdNumberValidator from "../validators/IdNumberValidator";
import PresenceValidator from "../validators/PresenceValidator";
import ValidatedInput from "../shared/ValidatedInput";
import TitleFromIdNumber from "../input_formatting/title_from_id_number";

import DateUtils from "@date-io/date-fns";
import { DatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";

export default class PersonalDetailsStep extends Component {
  static propTypes = {
    onNextClicked: PropTypes.func.isRequired,
    formData: PropTypes.object,
    identificationTypes: PropTypes.array,
    titleOptions: PropTypes.array,
  };

  static defaultProps = {
    title: "",
    formErrors: {
      firstNames: "",
      lastName: "",
      identificationNumber: "",
      identificationType: "",
      dateOfBirth: "",
    },
    firstNamesValid: false,
    lastNameValid: false,
    identificationNumberValid: false,
    formValid: false,
  };

  constructor(props) {
    super(props);
    this.state = Object.assign(
      {},
      PersonalDetailsStep.defaultProps,
      props.formData || {}
    );
    this.state.identification_type = this.props.formData.identification_type;
    this.state.title = this.props.formData.title;
    this.titleFromIdNumber = new TitleFromIdNumber();

    this.IDENTIFICATION_TYPES = {};
    this.TITLE_OPTIONS = {};

    this.props.identificationTypes.map((data) => {
      this.IDENTIFICATION_TYPES = {
        ...this.IDENTIFICATION_TYPES,
        [data[0]]: data[1],
      };
    });

    this.props.titleOptions.map((data) => {
      this.TITLE_OPTIONS = { ...this.TITLE_OPTIONS, [data[0]]: data[1] };
    });
  }

  componentDidMount() {
    this.validateInput("first_names", this.state.first_names);
    this.validateInput("last_name", this.state.last_name);
    this.validateInput(
      "identification_number",
      this.state.identification_number
    );

    if (!this.state.title) {
      this.setState({
        title: this.titleFromIdNumber.determineTitle(
          this.state.identification_number,
          this.TITLE_OPTIONS["Mr"],
          this.TITLE_OPTIONS["Mrs"]
        ),
      });
    }
  }

  onNextClicked = (e) => {
    e.preventDefault();
    this.props.onNextClicked({
      title: this.state.title,
      first_names: this.state.first_names,
      last_name: this.state.last_name,
      identification_number: this.state.identification_number,
      identification_type: this.state.identification_type,
      date_of_birth: this.state.date_of_birth,
    });
  };

  handleChange = (e) => {
    const value = e.target.value;
    const name = e.target.name;
    this.setState({ [name]: value }, () => {
      this.validateInput(name, value);
    });
  };

  handleDateChange = (name) => (value) => {
    this.setState({ [name]: value }, () => {
      this.validateInput(name, value);
    });
  };

  handlePhoneChange = (name, value) => {
    this.setState({ [name]: value }, () => {
      this.validateInput(name, value);
    });
  };

  validateInput(name, value) {
    let fieldValidationErrors = this.state.formErrors;

    switch (name) {
      case "first_names":
        let firstNamesValid = this.state.firstNamesValid;
        firstNamesValid = PresenceValidator.isValid(value);
        fieldValidationErrors.firstNames = firstNamesValid
          ? ""
          : "First names is required";
        this.setState(
          {
            formErrors: fieldValidationErrors,
            firstNamesValid: firstNamesValid,
          },
          this.validateForm
        );
        break;
      case "last_name":
        let lastNameValid = this.state.lastNameValid;
        lastNameValid = PresenceValidator.isValid(value);
        fieldValidationErrors.lastName = lastNameValid
          ? ""
          : "Last name is required";
        this.setState(
          {
            formErrors: fieldValidationErrors,
            lastNameValid: lastNameValid,
          },
          this.validateForm
        );
        break;
      case "identification_number":
        let identificationNumberValid = this.state.identificationNumberValid;
        if (this.state.identification_type === "passport") {
          identificationNumberValid = this.isPassportNumberValid(value);
          fieldValidationErrors.identificationNumber = identificationNumberValid
            ? ""
            : "Passport number is invalid";
        } else {
          identificationNumberValid = IdNumberValidator.isValid(value);
          fieldValidationErrors.identificationNumber = identificationNumberValid
            ? ""
            : "ID number is invalid";
        }
        this.setState(
          {
            formErrors: fieldValidationErrors,
            identificationNumberValid: identificationNumberValid,
          },
          this.validateForm
        );
        break;
      default:
        break;
    }
  }

  isPassportNumberValid(value) {
    return value.length >= 6 && value.length <= 9;
  }

  validateForm() {
    let isValid =
      this.state.firstNamesValid &&
      this.state.lastNameValid &&
      this.state.identificationNumberValid;
    this.setState({ formValid: isValid });
  }

  render() {
    return (
      <div>
        <form
          className="simple_form form form--dark"
          action="#"
          acceptCharset="UTF-8"
          method="post"
        >
          <div className="form__inputs">
            <fieldset>
              <ValidatedInput
                label="Title"
                name="title"
                value={this.state.title}
                className="select is-third"
                inputType="select"
                onChange={this.handleChange}
                options={this.TITLE_OPTIONS}
              />

              <ValidatedInput
                label="First names"
                name="first_names"
                value={this.state.first_names}
                isRequired
                className="is-two-thirds"
                validator={(val) => {
                  if (!PresenceValidator.isValid(val)) {
                    return "First names is required";
                  }
                }}
                onChange={this.handleChange}
              />
            </fieldset>
            <fieldset>
              <ValidatedInput
                label="Last names"
                name="last_name"
                value={this.state.last_name}
                isRequired
                validator={(val) => {
                  if (!PresenceValidator.isValid(val)) {
                    return "Last names is required";
                  }
                }}
                onChange={this.handleChange}
              />
            </fieldset>
            <fieldset>
              <ValidatedInput
                label="Identification Type"
                name="identification_type"
                value={this.state.identification_type}
                className="select is-half"
                inputType="select"
                isRequired
                onChange={this.handleChange}
                options={this.IDENTIFICATION_TYPES}
              />

              <ValidatedInput
                label="Identification Number"
                name="identification_number"
                value={this.state.identification_number}
                className="select is-half"
                isRequired
                maxLength={13}
                validator={(val) => {
                  if (this.state.identification_type === "passport") {
                    if (!this.isPassportNumberValid(val)) {
                      return "A valid Passport Number is required";
                    }
                  } else if (!IdNumberValidator.isValid(val)) {
                    return "A legitimate ID Number is required";
                  }
                }}
                onChange={this.handleChange}
              />
            </fieldset>
            <fieldset className="form__input">
              <div className="form-group">
                {this.state.identification_type === "passport" && (
                  <div className="form-input form-input--large has-floating-label is-half">
                    <label className="form-control">
                      <div className="form-control__label">
                        <span>Date of birth</span>
                      </div>
                      <div className="form-control__input">
                        <MuiPickersUtilsProvider utils={DateUtils}>
                          <DatePicker
                            name="date_of_birth"
                            value={this.state.date_of_birth}
                            onChange={this.handleDateChange("date_of_birth")}
                            format="yyyy-MM-dd"
                          />
                        </MuiPickersUtilsProvider>
                      </div>
                    </label>
                  </div>
                )}
              </div>
            </fieldset>
          </div>
          <div className="form__actions">
            <button
              className="button"
              onClick={this.onNextClicked}
              disabled={!this.state.formValid}
            >
              Continue
            </button>
          </div>
        </form>
        <PaginationDots activeIndex={2} />
      </div>
    );
  }
}
